<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import Card from '#components/card.svelte'
	import type { Blok, Cards } from '#library/components.schema.build.ts'

	interface Props {
		blok: Blok<Cards>
	}

	let { blok }: Props = $props()
</script>

<section class="cards {blok.theme || 'theme-pink-on-lupton'}" class:pattern={blok.pattern} {...attrs(blok)}>
	<div class="contain" class:narrow={blok.items?.length !== undefined && blok.items.length < 3}>
		<div class="title">{blok.title}</div>
		<div class="subtitle">{blok.subtitle}</div>
		{#if blok.items}
			<div class="items">
				{#each blok.items as { suptitle, title, subtitle, body, image, theme, shape, link }, i (i)}
					<Card
						{suptitle}
						title={title!}
						{subtitle}
						{body}
						image={image!}
						{i}
						{theme}
						{shape}
						href={link?.url}
					/>
				{/each}
			</div>
		{/if}
	</div>
</section>

<style lang="css">
	.cards {
		background-image: none;
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));

		&.pattern {
			background-image: var(--pattern);
		}
	}

	.contain {
		background-color: var(--c-background);
		color: var(--c-foreground);
		container: inline-size;
		padding: 1.5rem 1.25rem 1.25rem;
		text-align: center;

		@media (--from-tablet) {
			padding: 3.75rem 5.5rem 5rem;

			&.narrow {
				max-width: 66rem;
				padding-inline: 5.5cqi;
			}
		}
	}

	.title {
		font: 500 var(--f-h3);
		letter-spacing: var(--ls-h3);
		text-wrap: balance;

		@media (--from-mobile) {
			font: 600 var(--f-h2);
			letter-spacing: var(--ls-h2);
		}
	}

	.subtitle {
		font: 400 var(--f-body1);
		letter-spacing: var(--ls-body1);
		margin: 1.25rem auto 1rem;
		max-width: 54ch;

		@media (--from-mobile) {
			font: 400 var(--f-h6);
			letter-spacing: var(--ls-h6);
			margin: 1.25rem auto 2rem;
		}
	}

	.items {
		display: flex;
		gap: 1rem;
		flex-direction: column;

		@media (--from-mobile) {
			flex-direction: row;
			gap: 1.5rem;
			justify-content: center;
		}

		@media (--from-tablet) {
			gap: 2.5rem;
		}
	}
</style>
